<template>
  <div>
    <!-- Info Banner -->
    <div class="form-info-banner">
      <h3 class="form-info-banner-title">
        Os campos com * são de preenchimento obrigatório
      </h3>
      <p class="form-info-banner-text">
        Caso queira, você poderá salvar e continuar depois.
      </p>
    </div>

    <!-- Seção: Declarações de Vínculo -->
    <section class="form-section">
      <div class="form-section-header">
        <LabelDisclaimer
          :TamanhoFonteLabel="'H5'"
          :NomeLabel="'Declarações de Vínculo'"
          :Sessao="'Declarações'"
          :SubSessao="'Vinculo'"
        />
      </div>
      <div class="form-section-content">
        <div class="form-grid-1">
          <div class="form-field">
            <label class="form-field-label form-field-label-required">
              Possui vínculo com alguma Corretora de Valores Mobiliários?
              (conforme conceito definido na ICVM nº 505/11)
            </label>
            <div class="form-radio-group">
              <label class="form-radio-item">
                <input
                  type="radio"
                  value="sim"
                  name="VinculoCorretora"
                  class="form-radio-input"
                  v-model="localFI.VinculoCorretora"
                  @change="salvarAlteracoesLocalmente"
                />
                <span class="form-radio-label">Sim, à {{ nomeEmpresa }}</span>
              </label>
              <label class="form-radio-item">
                <input
                  type="radio"
                  value="sim-outra"
                  name="VinculoCorretora"
                  class="form-radio-input"
                  v-model="localFI.VinculoCorretora"
                  @change="salvarAlteracoesLocalmente"
                />
                <span class="form-radio-label">Sim, à outra corretora</span>
              </label>
              <label class="form-radio-item">
                <input
                  type="radio"
                  value="não"
                  name="VinculoCorretora"
                  class="form-radio-input"
                  v-model="localFI.VinculoCorretora"
                  @change="salvarAlteracoesLocalmente"
                />
                <span class="form-radio-label">Não</span>
              </label>
            </div>
          </div>
        </div>

        <div class="form-grid-1">
          <div class="form-field">
            <label
              class="form-field-label form-field-label-required"
              for="especificar"
              >Especificar</label
            >
            <textarea
              id="especificar"
              v-model="localFI.VinculoCorretoraEspecificar"
              @change="salvarAlteracoesLocalmente"
              class="field"
            ></textarea>
          </div>
        </div>

        <div class="form-grid-1">
          <div class="form-field">
            <label class="form-field-label form-field-label-required">
              Possui sócios, administradores, representantes ou relacionamento
              com pessoas que desempenham ou desempenharam nos últimos 5 anos,
              no Brasil ou em outros países cargo, emprego ou função pública
              relevante?
            </label>
            <div class="form-radio-group">
              <label class="form-radio-item">
                <input
                  type="radio"
                  value="false"
                  name="FuncaoPublicaRelevante"
                  class="form-radio-input"
                  v-model="localFI.FuncaoPublicaRelevante"
                  @change="salvarAlteracoesLocalmente"
                />
                <span class="form-radio-label">Não</span>
              </label>
              <label class="form-radio-item">
                <input
                  type="radio"
                  value="true"
                  name="FuncaoPublicaRelevante"
                  class="form-radio-input"
                  v-model="localFI.FuncaoPublicaRelevante"
                  @change="salvarAlteracoesLocalmente"
                />
                <span class="form-radio-label">Sim</span>
              </label>
            </div>
          </div>
        </div>

        <PEP
          v-if="
            localFI.FuncaoPublicaRelevante == 'true' ||
            localFI.FuncaoPublicaRelevante == true
          "
        />
      </div>
    </section>

    <!-- Seção: Documentos e Declarações -->
    <DeclaracoesDocumentos />
  </div>
  <ModalInformativoDocumentosDeclaracoes_PJ_Fundos />
  <ModalStatusAssinatura />
  <ModalAlerta
    :mostrar="modalAlerta.mostrar"
    :tipo="modalAlerta.tipo"
    :titulo="modalAlerta.titulo"
    :mensagem="modalAlerta.mensagem"
    @fechar="modalAlerta.mostrar = false"
  />
</template>

<script>
import { mapGetters } from "vuex";
import ModalInformativoDocumentosDeclaracoes_PJ_Fundos from "../Documentos/ModalInformativoDocumentosDeclaracoes_PJ_Fundos.vue";
import DeclaracoesDocumentos from "./DeclaracoesDocumentos.vue";
import ModalStatusAssinatura from "../Documentos/ModalStatusAssinaturaDeclaracoes_PJ_Fundos.vue";
import PEP from "./Pep.vue";
import LabelDisclaimer from "@/components/LabelDisclaimer.vue";
import ModalAlerta from "../Utilitarios/ModalAlerta.vue";

export default {
  name: "CadastroOutros_OutrasInformacoes",
  props: ["informacoesDeclaracoes", "Edicao"],
  components: {
    DeclaracoesDocumentos,
    ModalInformativoDocumentosDeclaracoes_PJ_Fundos,
    PEP,
    ModalStatusAssinatura,
    LabelDisclaimer,
    ModalAlerta,
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
      listaDocumentos: "GET_LISTA_DOCUMENTOS",
      listaDocumentosCliente: "GET_LISTA_DOCUMENTOS_CLIENTE",
      listaPep: "GET_LISTA_PEP_FI",
    }),
  },
  data() {
    return {
      modalAlerta: {
        mostrar: false,
        tipo: "warning",
        titulo: "",
        mensagem: "",
      },
      permitirAvancar: false,
      localFI: this.informacoesDeclaracoes || {},
      nomeEmpresa: "",
    };
  },
  mounted() {
    this.nomeEmpresa = process.env.VUE_APP_NOME_EMPRESA;
  },
  methods: {
    async validarFormulario(submeter) {
      let permitirAvancar = true;
      var nomeDoCampoDocumento = "";

      if (!this.localFI.VinculoCorretora) {
        this.permitirAvancar = false;
        this.modalAlerta = {
          mostrar: true,
          tipo: "warning",
          titulo: "Atenção: Campo obrigatório",
          mensagem:
            "O campo Vínculo Corretora é obrigatório e não foi informado, informe para avançar",
        };
        return false;
      }

      if (
        this.localFI.VinculoCorretora &&
        this.localFI.VinculoCorretora.toUpperCase().includes("SIM") &&
        !this.localFI.VinculoCorretoraEspecificar
      ) {
        permitirAvancar = false;

        this.modalAlerta = {
          mostrar: true,
          tipo: "warning",
          titulo: "Atenção: Campo obrigatório",
          mensagem:
            "O campo Vínculo Corretora foi informado como 'Sim', é obrigatório especificar este vínculo em 'Especificar*'",
        };
        return false;
      }

      if (
        this.localFI.FuncaoPublicaRelevante === null ||
        this.localFI.FuncaoPublicaRelevante === undefined
      ) {
        this.permitirAvancar = false;
        this.modalAlerta = {
          mostrar: true,
          tipo: "warning",
          titulo: "Atenção: Campo obrigatório",
          mensagem:
            "O campo 'Vínculo com pessoa pública relevante' é obrigatório e não foi informado, informe para avançar",
        };
        return false;
      }
      if (
        (this.localFI.FuncaoPublicaRelevante == true ||
          this.localFI.FuncaoPublicaRelevante == "true") &&
        !this.listaPep.length > 0
      ) {
        permitirAvancar = false;

        this.modalAlerta = {
          mostrar: true,
          tipo: "warning",
          titulo: "Atenção: Campo obrigatório",
          mensagem:
            "Se houver vínculo com pessoa que ocupe cargo, emprego ou função pública relevante, é obrigatório incluir a pessoa para avançar.",
        };
        return false;
      }

      if (this.listaDocumentos != null) {
        this.listaDocumentos.forEach((documentoObj) => {
          if (
            documentoObj.TipoCliente == "Investidor" &&
            documentoObj.Obrigatoriedade == "Sim"
          ) {
            if (!this.listaDocumentosCliente) {
              this.permitirAvancar = false;
              nomeDoCampoDocumento = documentoObj.NomeDocumento;
            } else if (
              !this.listaDocumentosCliente.some(
                (p) =>
                  p != null &&
                  documentoObj != null &&
                  p.TemplateId === documentoObj.TemplateId,
              ) ||
              this.listaDocumentosCliente.some(
                (p) =>
                  p != null &&
                  documentoObj != null &&
                  p.TemplateId === documentoObj.TemplateId &&
                  p.StatusAssinatura != "Assinado",
              )
            ) {
              this.permitirAvancar = false;
              nomeDoCampoDocumento = documentoObj.NomeDocumento;
            }
          }
        });
      }
      if (submeter && nomeDoCampoDocumento != "") {
        this.modalAlerta = {
          mostrar: true,
          tipo: "warning",
          titulo: "Atenção: Documento obrigatório",
          mensagem: `O documento ${nomeDoCampoDocumento} é obrigatório e não foi assinado, aceite os termos para avançar`,
        };

        permitirAvancar = false;
      }

      this.permitirAvancar = permitirAvancar;
      return permitirAvancar;
    },
    async proximaEtapa() {
      const podeAvancar = await this.validarFormulario(true);

      if (podeAvancar) {
        this.$store.commit("SET_ETAPA_CADASTRO", 7);
        this.$store.commit("SET_SALVAR_INFO_DES_NOTIFICACAO", true);
        this.salvarInformacoes();
      }
    },
    salvarInformacoes() {
      this.$store.commit("SET_FI_SALVAR_INFO", true);
    },
    salvarAlteracoesLocalmente() {
      this.$store.commit("SET_FI_SALVAR_INFO_DECLARACAO", this.localFI);
      //this.validarFormulario();
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap");
</style>
